import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import style from './style'
import propTypes from './prop'
import MediaHeader from '../../components/media/header'
import { Grid, Box, Tab, Tooltip, Typography } from '@material-ui/core'

import { mediaDirectoryGetRoot } from '../../reducers/media-directory/action'
import withStyles from '@material-ui/core/styles/withStyles'
import MediaItemFactory from '../../components/media/item/factory'
import translator from '../../translate'
import { mediaImageUploadAction } from '../../reducers/media-image/action'
import { componentBoxHideAction } from '../../reducers/component-box/action'
import {
  MediaDirectoryFieldNames,
  MediaItemType,
} from '../../model/media-directory'
import { mediaVideoUploadAction } from '../../reducers/media-video/action'
import {
  mediaVideoStreamingUploadStartAction,
  mediaVideoStreamingUploadCancelAction,
  mediaVideoStreamingUploadSuccessAction,
  mediaVideoStreamingUploadProgressAction,
} from '../../reducers/media-video/action'

import URL from 'src/api/url'

import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { Pagination } from '@material-ui/core'
import { CoreButton, CoreIconButton, CoreTextField } from 'src/components/core'
import MediaItemVideo from 'src/components/media/item/video'
import VideoUploadProgress from 'src/components/media/item/video-upload-progress'
import { SearchBar } from '../image-gallery/search-bar'

const VideoGallery = ({
  classes,
  popupType,
  onOk,
  //setImageURL,
}) => {
  const dispatch = useDispatch()
  const entity = useSelector(state => state.mediaDirectory.entity)
  const streamingUploads = useSelector(
    state => state.mediaVideo.streamingUploads,
  )

  // Split state into logical pieces
  const [items, setItems] = useState([])
  const [tabValue, setTabValue] = useState(1)
  const [folderId, setFolderId] = useState(null)
  const [page, setPage] = useState(1)
  const [filterText, setFilterText] = useState('')
  const [debouncedFilterText, setDebouncedFilterText] = useState('')

  const getMediaItemType = useCallback(fileType => {
    if (fileType === 'video/mp4' || fileType === 'video/mov') {
      return MediaItemType.VIDEO
    }

    return null
  }, [])

  // Effect for handling items changes
  useEffect(() => {
    if (items.length > 0) {
      onOk(items)
    }
  }, [items, onOk])

  const refreshList = useCallback(() => {
    setPage(1)
    dispatch(mediaDirectoryGetRoot(1, debouncedFilterText, 'video'))
  }, [dispatch, debouncedFilterText])

  const handleSelect = item => {
    //setImageURL(`${URL.STORAGE}${item.url}`)
    setItems([item])
  }

  // Generate unique upload ID
  const generateUploadId = useCallback(() => {
    return `upload_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }, [])

  // Handle streaming upload
  const handleStreamingUpload = useCallback(
    file => {
      const uploadId = generateUploadId()

      dispatch(mediaVideoStreamingUploadStartAction(file, folderId, uploadId))
    },
    [dispatch, folderId, generateUploadId],
  )

  // Cancel upload
  const handleCancelUpload = useCallback(
    uploadId => {
      dispatch(mediaVideoStreamingUploadCancelAction(uploadId))
    },
    [dispatch],
  )

  const onDrop = useCallback(
    e => {
      if (tabValue !== 6) {
        const file = e.dataTransfer.files[0]
        const mediaType = getMediaItemType(file.type)
        if (!mediaType) return

        handleStreamingUpload(file)
        setTabValue(1)
        e.preventDefault()
        e.stopPropagation()
      }
    },
    [tabValue, getMediaItemType, handleStreamingUpload],
  )

  const onDragEnter = useCallback(
    e => {
      if (tabValue !== 6) {
        const fileType = e.dataTransfer.items[0].type
        const mediaType = getMediaItemType(fileType)

        if (!mediaType) {
          e.preventDefault()
          e.dataTransfer.effectAllowed = 'none'
          e.dataTransfer.dropEffect = 'none'
          setTabValue(0)
          return false
        }

        setTabValue(1)
        e.stopPropagation()
      }
    },
    [tabValue, getMediaItemType],
  )

  const onDragOver = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  const onDragLeave = useCallback(
    e => {
      if (tabValue !== 6) {
        setTabValue(1)
        e.stopPropagation()
      }
    },
    [tabValue],
  )

  const choosePhoto = useCallback(
    (e, type) => {
      const file = e.target.files[0]
      const mediaType = getMediaItemType(file.type)

      if (!mediaType) return

      handleStreamingUpload(file)
      setTabValue(1)

      // Reset the file input value to allow selecting the same file again
      e.target.value = ''

      e.preventDefault()
      e.stopPropagation()
    },
    [getMediaItemType, handleStreamingUpload],
  )

  // Debounce filter text
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilterText(filterText)
    }, 500) // 500ms delay

    return () => clearTimeout(timer)
  }, [filterText])

  // Handle pagination changes
  useEffect(() => {
    dispatch(mediaDirectoryGetRoot(page, debouncedFilterText, 'video'))
  }, [dispatch, page, debouncedFilterText])

  // Reset page to 1 when filter text changes
  useEffect(() => {
    setPage(1)
  }, [filterText])

  const inputFileRef = React.useRef()

  // Get active uploads (not completed or available)
  const activeUploads = Object.values(streamingUploads).filter(
    upload => upload.status !== 'available' && upload.status !== 'completed',
  )

  return (
    <Grid
      container
      className={classes.root}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {/*       <MediaHeader closeHandler={closeHandler} popupType={popupType} />
       */}{' '}
      <TabContext value={tabValue}>
        <React.Fragment>
          <Grid
            container
            className={classes.content}
            justifyContent="flex-start"
            alignContent="flex-start"
            alignItems="stretch"
          >
            <div className={classes.headerRow}>
              <SearchBar value={filterText} onChange={setFilterText} />
              <Tooltip
                title={
                  <Typography
                    style={{
                      fontSize: '12px',
                      fontWeight: 400,
                      color: '#fff',
                      padding: '8px',
                    }}
                  >
                    Maximum upload size: 100MB per video. <br /> Supported
                    format: MP4.
                  </Typography>
                }
                placement="bottom"
                arrow
              >
                <CoreButton onClick={() => inputFileRef.current.click()}>
                  Upload
                </CoreButton>
              </Tooltip>
              <input
                type="file"
                ref={inputFileRef}
                accept="video/mp4, video/mov"
                onChange={event => choosePhoto(event)}
                className={classes.imageUploadInput}
              />
            </div>

            <div className={classes.mediaContainer}>
              {(entity && entity.results.length !== 0) ||
              activeUploads.length > 0 ? (
                <div className={classes.imageList}>
                  {/* Show active uploads */}
                  {activeUploads.map(upload => (
                    <VideoUploadProgress
                      key={upload.id}
                      upload={upload}
                      onCancel={handleCancelUpload}
                    />
                  ))}

                  {/* Show existing videos */}
                  {entity &&
                    entity.results.map(mediaItem => {
                      mediaItem.type = MediaItemType.VIDEO
                      mediaItem.dispatch = dispatch

                      let mediaProps = {
                        ...mediaItem,
                        key: mediaItem.id,
                        onSelect: handleSelect,
                        refreshList: refreshList,
                      }

                      return <MediaItemVideo {...mediaProps} />
                    })}
                </div>
              ) : (
                <div className={classes.entityNull}>
                  <img
                    src="/assets/editor-file/media/empty-media.svg"
                    alt=""
                  ></img>
                </div>
              )}
            </div>
            {entity?.totalPages > 0 && (
              <div className={classes.paginationContainer}>
                <Pagination
                  count={entity.totalPages || 1}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                  size="medium"
                  showFirstButton
                  showLastButton
                />
              </div>
            )}
          </Grid>
        </React.Fragment>
      </TabContext>
    </Grid>
  )
}

VideoGallery.propTypes = propTypes

export default withStyles(style, { withTheme: true })(VideoGallery)
